import { buildCombinationKey } from "@simplyk/common";
import * as uuid from "uuid";

import type { RateData } from "../types";

interface CloneRateOptions {
  canInheritGroupSize?: boolean;
}

export function cloneRateWithNewIds(
  rate: RateData,
  newName: string,
  { canInheritGroupSize = true }: CloneRateOptions = {}
): RateData {
  const valueIdMap = new Map<string, string>();

  const shopVariants = rate.shopVariants?.map((variant) => ({
    ...variant,
    id: uuid.v4(),
    values: variant.values.map((value) => {
      const newValueId = uuid.v4();
      valueIdMap.set(value.id, newValueId);
      return { ...value, id: newValueId };
    }),
  }));

  const variantSeats = rate.variantSeats?.map((seat) => ({
    ...seat,
    combinationKey: buildCombinationKey(seat.combinationKey.split(",").map((oldId) => valueIdMap.get(oldId) ?? oldId)),
    soldCount: 0,
  }));

  const photos = rate.photos?.map((photo) => ({ ...photo, id: uuid.v4() }));

  return {
    ...rate,
    id: uuid.v4(),
    name: newName,
    shopVariants,
    shopVariantsToDelete: [],
    variantSeats,
    photos,
    ...(canInheritGroupSize ? {} : { isGroup: false, attendeesByTicket: null }),
  };
}
